import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CreateEntityWidgetConfig } from '../config/create-entity-widget-config.types';
import { jemmaRequestContext, jemmaSecureBaseUrl } from '../http/jemma-request.util';
import { JemmaResponseModel } from '../organization/jemma-organization.types';
import { JemmaFacilityCreateRequest, JemmaFacilityCreateResponseData } from './jemma-facility.types';

/**
 * Minimal Jemma API client for the widget's Facility tab. Country reference
 * data is shared with the Organization tab via `JemmaOrganizationApiService.getCountries()`
 * rather than duplicated here, since it's the same codeset.
 *
 * Stateless: takes the calling widget instance's config on every call (see `JemmaOrganizationApiService`).
 */
@Injectable({ providedIn: 'root' })
export class JemmaFacilityApiService {
    private readonly _http = inject(HttpClient);

    createFacility(config: CreateEntityWidgetConfig, body: JemmaFacilityCreateRequest): Observable<JemmaFacilityCreateResponseData> {
        return this._http
            .post<JemmaResponseModel<JemmaFacilityCreateResponseData>>(`${jemmaSecureBaseUrl(config)}/facilities`, body, { context: jemmaRequestContext(config) })
            .pipe(
                map(response => {
                    if (!response.data) {
                        throw new Error('Jemma API returned no facility data.');
                    }
                    return response.data;
                })
            );
    }
}
